import React from "react";
import { TableBody } from "@mui/material";
import UsersTableRow from "./UsersTableRow";

const UsersTableUserMap = ({ users, onEdit, onDelete, roleBasedOptions, isBuyer }) => {
    return <TableBody>
        {
            users.map((user) => {
                return (
                    <UsersTableRow
                        key={user.username}
                        user={user}
                        onEdit={onEdit}
                        onDelete={onDelete}
                        roleBasedOptions={roleBasedOptions}
                        isBuyer={isBuyer}
                    />
                )
            }
        ) }
        </TableBody>

};
export default UsersTableUserMap;
